import { useLocalization } from "@tm/localization"
import { Controller, useFormContext } from "react-hook-form"
import { errorHandling } from "@tm/utils"
import { CurrencyField, WorkTimeField } from "@tm/components"

type Props = {
    repairTimesTextId: number
    defaultCurrencyCode?: string
}

const MAX_POSSIBLE_NUMBER = 99999.99

export function FixedPriceFields({ repairTimesTextId, defaultCurrencyCode }: Props) {
    const { translateText } = useLocalization()
    const { control } = useFormContext()

    return (
        <>
            <Controller
                control={control}
                name="time"
                render={({ field, fieldState }) => (
                    <WorkTimeField
                        label={translateText(repairTimesTextId)}
                        size="extralarge"
                        sx={{ width: "150px" }}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
            <Controller
                control={control}
                name="fixedPriceValue"
                render={({ field, fieldState }) => (
                    <CurrencyField
                        required
                        label={`${translateText(246)} ${defaultCurrencyCode}`}
                        size="extralarge"
                        sx={{ width: "150px" }}
                        max={MAX_POSSIBLE_NUMBER}
                        {...field}
                        {...errorHandling(fieldState)}
                    />
                )}
            />
        </>
    )
}
